<template>
  <div class="venn-diagram-main">
    <div class="venn-diagram" :style="`height:${venn_diag.styles.height}px; width:${venn_diag.styles.width}px`" @dragenter.prevent="dragEnter" @dragleave="dragLeave" @dragover.prevent @drop.prevent="drop">
      <svg class="svg-element" viewBox="0 0 528 358" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path id="mid-sec1" @dragenter.prevent="dragEnter" @dragleave="dragLeave" @dragover.prevent @drop.prevent="drop" :fill="venn_diag.styles.bg_color" d="M264.251 32C271.371 37.4714 278.124 43.5414 284.438 50.1789C316.81 84.2087 335 130.367 335 178.5C335 226.633 316.81 272.791 284.438 306.821C278.124 313.459 271.371 319.529 264.251 325M263.749 32C256.629 37.4714 249.876 43.5414 243.562 50.1789C211.19 84.2087 193 130.367 193 178.5C193 226.633 211.19 272.791 243.562 306.821C249.876 313.459 256.629 319.529 263.749 325" :stroke="venn_diag.styles.border_color" stroke-width="1"/>
        <path id="left-sec1" @dragenter.prevent="dragEnter" @dragleave="dragLeave" @dragover.prevent @drop.prevent="drop" :fill="venn_diag.styles.bg_color" d="M191.5 178.5C191.5 227.009 209.896 273.541 242.656 307.857C248.557 314.038 254.838 319.732 261.44 324.913C234.297 343.113 211.329 356.5 176.5 356.5C79.87 356.5 1.5 277.051 1.5 179C1.5 80.9495 79.87 1.5 176.5 1.5C211.349 1.5 234.33 13.9492 261.439 32.0875C254.837 37.2687 248.557 42.9622 242.656 49.1431C209.896 83.459 191.5 129.991 191.5 178.5Z" :stroke="venn_diag.styles.border_color" stroke-width="3"/>
        <path id="right-sec1" @dragenter.prevent="dragEnter" @dragleave="dragLeave" @dragover.prevent @drop.prevent="drop" :fill="venn_diag.styles.bg_color" d="M336.5 178.5C336.5 227.009 318.104 273.541 285.344 307.857C279.443 314.038 273.162 319.732 266.56 324.913C293.703 343.113 316.671 356.5 351.5 356.5C448.13 356.5 526.5 277.051 526.5 179C526.5 80.9495 448.13 1.5 351.5 1.5C316.651 1.5 293.67 13.9492 266.561 32.0875C273.163 37.2687 279.443 42.9622 285.344 49.1431C318.104 83.459 336.5 129.991 336.5 178.5Z" :stroke="venn_diag.styles.border_color" stroke-width="3"/>
      </svg>
    </div>
    <div v-if="draggable_objects">
      <div v-for="(obj, index) in draggable_objects" :key="`draggable_obj${index}`">
        <show-image v-if="obj.clipart && obj.clipart.clipart && obj.clipart.clipart.file" class="venn-diagram-box" :style="`left:${obj.x}px; top:${obj.y}px; height:${obj.clipart.height}px; width:${obj.clipart.width}px`" @dragstart.native="dragstart($event, index)" :draggable="all_draggable || obj.is_draggable"  :src="obj.clipart.clipart.file" :alt="`clipart${index}`" />
        <div v-if="obj.text" class="draggable-text-box" :style="propertyStyles(obj)" @dragstart="dragstart($event, index)" :draggable="all_draggable || obj.is_draggable">{{obj.text}}</div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import {getCSSFromStyles} from '@/components/Common/StyleEditor/utils'
import ShowImage from '@/components/General/ShowImage';
export default {
    name:"show-venn-diagram",
    components : {
      ShowImage
    },
    props: {
      venn_diag: {
        type: Object
      },
      all_draggable : {
        type : Boolean,
        default : false
      }
    },
    data(){
      return {
        draggable_objects: this.venn_diag.properties,
        newX: 0,
        newY: 0,
        current_index: 0,
        response: {},
      }
    },
    methods: {
      ...mapActions(['updateCurrentAnswer']),
      dragstart(e, index){
        this.current_index = index; 
      },
      drop(e){
        this.newX = e.offsetX ;
        this.newY = e.offsetY ;

        this.draggable_objects[this.current_index].x =  this.newX;
        this.draggable_objects[this.current_index].y =  this.newY;

        e.target.style.stroke = this.venn_diag.styles.border_color
        e.target.style.strokeWidth = 3

        this.setResponseObject(this.current_index, e.target.id);

        this.updateCurrentAnswer({key : "venn_diagram", value : this.checkAnswers()})
      },
      dragEnter(e){
        if(e.target.id === 'mid-sec1'){
          e.target.style.stroke = this.venn_diag.styles.glow_color
          e.target.style.strokeWidth = 4
        }else {
          e.target.style.stroke = this.venn_diag.styles.glow_color
          e.target.style.strokeWidth = 2
        }
      },
      dragLeave(e){
        e.target.style.stroke = this.venn_diag.styles.border_color
        e.target.style.strokeWidth = 3
      },
      getTotalDraggrableObjects(){
        return this.draggable_objects.filter((obj)=>obj.drag_on).length
      },
      formatter(section_string){
        const section_mapping = {'L': "left-sec1", 'R': "right-sec1", 'M': "mid-sec1"}
        return section_mapping[section_string]
      },
      setResponseObject(index, section){
        // sets the value of dropped object
        if(section === this.formatter(this.draggable_objects[index].drag_on)){
          this.response[index] = true;
        }
        else {
          this.response[index] = false;
        }
      },
      checkAnswers(){
        let total_objects = this.getTotalDraggrableObjects();
        const num_correct = Object.values(this.response).filter((val)=> !!val).length
       
        if(num_correct === total_objects && total_objects!=0){
          return true
        }else{
          return false
        }
      },
      propertyStyles(obj){
        const styles = getCSSFromStyles(obj.text_styles)
        styles['left'] = `${obj.x}px`
        styles['top'] = `${obj.y}px`
        return styles
      }
    },
    watch : {
      venn_diag : function(new_val){
        if(new_val){
          this.draggable_objects = new_val.properties
        }
      }
    }
}
</script>

<style scoped>
.venn-diagram-main {
  position: relative;
}
.venn-diagram {
  position: relative;
  display: flex;
  border: 1px solid #00b4d8;
  justify-content: center;
  align-items: center;
}
.svg-element {
  height: 80%;
  width: 80%;
}
.venn-diagram-box {
  height: 100px;
  width: 100px;
  position: absolute;
}
.draggable-text-box {
  height: auto;
  width: auto;
  padding: 8px 10px;
  position: absolute;
  border: 1px solid;
}
#svg_element {
  position: relative;
}
</style>
